import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Shop } from "../models/shop.model";
import { AlertService } from "./alert.service";
import { AuthService } from "./auth.service";
import { EndpointFactoryService } from "./endpoint-factory.service";
import { FileUpload } from "../models/fileUpload.model";
import { FileUploadStatus } from "../models/fileUploadStatus.model";

@Injectable()
export class FileUploadEndpointService extends EndpointFactoryService {

  protected URL: string = "/api/FileUpload/";

  constructor(http: HttpClient, alertService: AlertService, authService: AuthService) {
    super(http, alertService, authService);

  }

  public uploadFile(file: FormData, showError: boolean = true): Observable<any> {
    return this.postAuthorizedWithErrorHandling(this.URL + "UploadFile/", file, () => this.uploadFile(file, showError), null, showError);
  }


  public getAllFileUploads(showError: boolean = true): Observable<FileUpload[]> {
    return this.getAuthorizedWithErrorHandling(this.URL + 'FileUploads', () => this.getAllFileUploads(showError), null, showError);
  }

  public get(id: string, showError: boolean = true): Observable<FileUploadStatus[]> {
    return this.getAuthorizedWithErrorHandling(this.URL + 'FileUploadStatus/' + id, () => this.get(id, showError), null, showError);
  }

}
